import { PageContainer } from '@urbantxt/layout';
import React from 'react';

import { ParticlesBackground } from '@urbantxt/particles';
import styles from './BusinessCardPageLayout.module.scss';

interface Props {
  children: React.ReactNode;
}

export default function BusinessCardPageLayout({ children }: Props) {
  return (
    <PageContainer className={styles.pageOuter}>
      <div className={styles.particles}>
        <ParticlesBackground />
      </div>
      <div className={styles.page}>
        <main className={styles.formPane}>{children}</main>
      </div>
    </PageContainer>
  );
}
